"use client";

import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const capabilities = [{
  number: "01",
  name: "Website Erstellung",
  category: "WEB DESIGN — Individuelle Konzepte",
  description: "Wir entwickeln maßgeschneiderte Websites, die Ihre Marke perfekt repräsentieren. Modernes Design trifft auf intuitive Benutzerführung für ein erstklassiges digitales Erlebnis. Jetzt unsere Referenzen anschauen.",
  linkText: "Referenzen anschauen",
  linkTo: "/PortfolioPage",
  thumb: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/website_erstellung.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/website_erstellung.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/website_erstellung.png-wvc-sizes"
}, {
  number: "02",
  name: "Website Redesign",
  category: "MODERNISIERUNG — Frischer Glanz",
  description: "Bringen Sie Ihre bestehende Website auf das nächste Level. Wir optimieren Struktur, Design und Performance, um Ihre Online-Präsenz zukunftssicher zu gestalten.",
  thumb: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/website_redesign.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/website_redesign.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/website_redesign.png-wvc-sizes"
}, {
  number: "03",
  name: "SEO Betreuung",
  category: "SICHTBARKEIT — Gefunden werden",
  description: "Mit gezielter Suchmaschinenoptimierung sorgen wir dafür, dass Ihre Website bei Google ganz oben steht. Mehr Reichweite für Ihr Unternehmen in Oldenburg und darüber hinaus. Erfolgreiche Projekte sehen.",
  linkText: "Erfolgreiche Projekte sehen",
  linkTo: "/PortfolioPage",
  thumb: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/seo_betreuung.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/seo_betreuung.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/seo_betreuung.png-wvc-sizes"
}, {
  number: "04",
  name: "Landingpages",
  category: "KONVERSION — Fokus auf Ziele",
  description: "Hochperformante Landingpages, die Besucher in Kunden verwandeln. Wir setzen auf klare Botschaften und starke Call-to-Actions für maximale Ergebnisse.",
  thumb: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/landingpages.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/landingpages.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/landingpages.png-wvc-sizes"
}, {
  number: "05",
  name: "Lokale Unternehmenswebsites",
  category: "REGIONAL — Ihr Partner vor Ort",
  description: "Spezialisierte Lösungen für lokale Dienstleister. Wir verbinden Ihre regionale Stärke mit einer professionellen digitalen Visitenkarte, die Vertrauen schafft. Referenzen anschauen.",
  linkText: "Referenzen anschauen",
  linkTo: "/PortfolioPage",
  thumb: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/lokale_websites.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/lokale_websites.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/lokale_websites.png-wvc-sizes"
}, {
  number: "06",
  name: "Technische Optimierung",
  category: "PERFORMANCE — Schnelligkeit zählt",
  description: "Wir optimieren Ladezeiten und technische Stabilität. Eine schnelle Website ist nicht nur nutzerfreundlich, sondern auch ein entscheidender Ranking-Faktor.",
  thumb: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/technische_optimierung.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/technische_optimierung.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/technische_optimierung.png-wvc-sizes"
}, {
  number: "07",
  name: "Wartung und Pflege",
  category: "SICHERHEIT — Rundum sorglos",
  description: "Wir halten Ihre Website technisch aktuell und sicher. Regelmäßige Updates und Backups geben Ihnen die Freiheit, sich voll auf Ihr Kerngeschäft zu konzentrieren.",
  thumb: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/wartung_pflege.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/wartung_pflege.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/wartung_pflege.png-wvc-sizes"
}];
export default function Services() {
  const intro = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const cta = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="3713" id="website-erstellung" className="bg-background text-foreground pt-32 md:pt-44 lg:pt-[180px] pb-24 md:pb-32 px-6 md:px-10 lg:px-16">
      <div className="max-w-[1440px] mx-auto">
        <div ref={intro.ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 mb-20 md:mb-28 transition-all duration-1000 ease-out ${intro.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-8">
              <span className="h-px w-10 bg-primary" />
              <span className="font-mono text-xs tracking-[0.2em] text-primary uppercase">
                Leistungen
              </span>
            </div>
            <h2 className="font-default font-light text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-foreground">
              Digitale Lösungen, die Ihr Unternehmen{" "}
              <em className="font-serif italic font-normal text-primary">
                nachhaltig stärken
              </em>
              .
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pt-6">
            <p className="font-default text-base md:text-lg leading-relaxed text-foreground/70 max-w-md">
              Orvo Web ist Ihre Webdesign-Agentur aus Oldenburg. Wir verbinden technisches Know-how mit ästhetischem Anspruch, um digitale Erlebnisse zu schaffen, die Ihre Kunden überzeugen und Ihr Wachstum fördern.{" "}
              <Link to="/ContactPage" className="text-primary underline underline-offset-4 hover:text-primary/80 transition-colors">
                Kontakt aufnehmen
              </Link>
            </p>
            <p className="font-mono text-xs tracking-[0.18em] uppercase text-muted-foreground mt-8">
              Sieben Disziplinen. Ein Ziel. Premium Qualität.
            </p>
          </div>
        </div>

        <div className="border-t border-border">
          {capabilities.map((item, i) => {
          const row = useRevealOnScroll<HTMLDivElement>({
            threshold: 0.15
          });
          const renderDescription = () => {
            if ('linkText' in item && 'linkTo' in item) {
              const parts = item.description.split(item.linkText as string);
              return <>
                    {parts[0]}
                    <Link to={item.linkTo as string} className="text-primary underline underline-offset-4 hover:text-primary/80 transition-colors">
                      {item.linkText as string}
                    </Link>
                    {parts[1]}
                  </>;
            }
            return item.description;
          };
          return <div data-index={i} ref={row.ref} key={item.number} className={`group relative border-b border-border transition-all duration-700 ease-out ${row.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
            transitionDelay: `${i * 60}ms`
          }}>
                <span className="absolute left-0 top-0 h-full w-px bg-primary scale-y-0 group-hover:scale-y-100 origin-top transition-transform duration-500 ease-out" />

                <div className="absolute inset-0 bg-card opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />

                <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 items-start lg:items-center py-10 md:py-14 px-2 md:px-6">
                  <div className="lg:col-span-1">
                    <span className="font-mono font-light text-5xl md:text-6xl lg:text-[6rem] leading-none text-primary group-hover:opacity-100 opacity-70 transition-opacity duration-500">
                      {item.number}
                    </span>
                  </div>

                  <div className="lg:col-span-4 lg:pl-4">
                    <h3 className="font-default font-light text-3xl md:text-4xl leading-tight tracking-tight text-foreground mb-3">
                      {item.name}
                    </h3>
                    <p className="font-mono text-[10px] md:text-xs tracking-[0.2em] uppercase text-muted-foreground">
                      {item.category}
                    </p>
                  </div>

                  <div className="lg:col-span-5">
                    <p className="font-default text-base md:text-[17px] leading-relaxed text-foreground/80">
                      {renderDescription()}
                    </p>
                  </div>

                  <div className="lg:col-span-2 flex items-center gap-4 lg:justify-end">
                    <Link to="/PortfolioPage" className="group/link inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.18em] uppercase text-foreground hover:text-primary transition-colors duration-300">
                      <span className="border-b border-foreground/40 group-hover/link:border-primary pb-0.5 transition-colors">
                        Referenzen
                      </span>
                      <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover/link:translate-x-0.5 group-hover/link:-translate-y-0.5" />
                    </Link>
                    <div className="relative w-12 h-12 md:w-14 md:h-14 rounded-lg overflow-hidden border border-border shrink-0 ring-0 group-hover:ring-2 group-hover:ring-primary/40 transition-all duration-500">
                      <img src={item.thumb} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.name} loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div ref={cta.ref} className={`mt-20 md:mt-24 bg-card rounded-lg px-8 md:px-12 py-10 md:py-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 transition-all duration-1000 ${cta.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div>
            <p className="font-mono text-[11px] tracking-[0.2em] uppercase text-primary mb-3">
              Bereit für den nächsten Schritt?
            </p>
            <h3 className="font-default font-light text-2xl md:text-3xl lg:text-4xl leading-tight tracking-tight text-foreground">
              Haben Sie ein Projekt im Kopf?{" "}
              <em className="italic text-primary">Lassen Sie uns sprechen.</em>
            </h3>
          </div>
          <Link to="/ContactPage" className="shrink-0">
            <Button size="lg" className="font-default text-xs tracking-[0.18em] uppercase rounded-lg px-8 h-12 bg-primary text-primary-foreground hover:bg-primary/90">
              Jetzt kostenlose Ersteinschätzung anfragen
              <ArrowUpRight className="w-4 h-4 ml-1" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}